export default class Cart {
    constructor() {

        this.pageAction = false;
        this.isProcessing = false;
        this.requestType = "POST";
        this.requestData = {};
        this.cartData = {};
        this.requestURI = null;

        this.execute = this.execute.bind(this);
        this.hasProcess = this.hasProcess.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.updateCart = this.updateCart.bind(this);
        this.removeFromCart = this.removeFromCart.bind(this);
        this.listCart = this.listCart.bind(this);
        this.setAsCheckoutPageAction = this.setAsCheckoutPageAction.bind(this);
        this.setPageAction = this.setPageAction.bind(this);
        this.getPageAction = this.getPageAction.bind(this);
        this.resetPageAction = this.resetPageAction.bind(this);
        this.updateCartCount = this.updateCartCount.bind(this);
        this.getCart = this.getCart.bind(this);
        this.checkCartItems = this.checkCartItems.bind(this);
        this.fireEvent = this.fireEvent.bind(this);

    }

    getCart() {
        return this.cartData;
    }

    hasProcess() {
        return this.isProcessing;
    }

    execute() {
        this.requestData._page_action = this.pageAction || 'default_page';
        const self = this;
        this.requestData._language = window.application.language;
        this.requestData[application.requestToken.key] = application.requestToken.value;
        this.isProcessing = true;

        if (localStorage.getItem('ooredoo_cart_sid') && typeof localStorage.getItem('ooredoo_cart_sid') === 'string' && localStorage.getItem('ooredoo_cart_sid').length) {
            // this.requestData['ooredoo_cart_sid'] = localStorage.getItem('ooredoo_cart_sid');
        }

        return $.ajax({
            url: this.requestURI,
            type: this.requestType,
            dataType: 'json',
            headers: {
                'Xsrf-K': application.requestToken.key,
                'Xsrf-V': application.requestToken.value
            },
            beforeSend: function () {
                $('#loader').removeClass('hidden')
            },
            data: this.requestData,

            success: function (response) {
                self.resetPageAction();
                self.updateCartCount(response.cart.count);
                if (response.cart) {
                    self.cartData = response.cart;
                }

                if (typeof response.cart.cid === 'string' && response.cart.cid.length) {
                    // localStorage.setItem('ooredoo_cart_sid', response.cart.cid)
                }

                return response;
            },
            error: function (error) {

                self.resetPageAction();
                return error;
            },
            complete: function () {
                this.isProcessing = false;
                $('#loader').addClass('hidden')
            },
        });
    }

    setAsCheckoutPageAction() {
        this.setPageAction('checkout_page');
    }

    resetPageAction() {
        this.setPageAction('default_page');
    }

    setPageAction(page) {
        this.pageAction = page;
    }

    getPageAction() {
        return this.pageAction;
    }

    updateCartCount(_count) {
        var _cartCountsHolders = $('.js-shadow-cart-count');
        if (_cartCountsHolders.length) {
            const parent = _cartCountsHolders.closest('.js-shadow-cart-count-wrapper');
            if (!isNaN(_count) && _count * 1 > 0) {
                _cartCountsHolders.text(_count).removeClass('hidden').addClass('active');
                parent.addClass('has-products');
                parent.removeClass('has-no-products');
            } else {
                _cartCountsHolders.text('').removeClass('active').addClass('hidden');
                parent.addClass('has-no-products');
                parent.removeClass('has-products');
            }
        }
    }

    addToCart(product_id, product_quantity = 1, data = {}) {
        this.requestType = "POST";
        this.requestURI = application.ods.urls.cart.add;
        this.requestData = {
            product_id: product_id,
            quantity: product_quantity,
            data: data,
        };
        return this.execute()
            .then((response) => {
                this.fireEvent('shop:cart.add_product.success', {
                    cart: this.cartData,
                    response: response
                });
                return response;
            })
            .catch((response) => {
                this.fireEvent('shop:cart.add_product.failed', {
                    cart: this.cartData,
                    response: response
                });

                this.fireEvent('shop:cart.response.failed', {
                    cart: this.cartData,
                    response: response
                });
                return response;

            });

    }

    updateCart(cart_id, product_id, product_quantity = 1, data = {}) {
        this.requestType = "POST";
        this.requestURI = application.ods.urls.cart.update;
        this.requestData = {
            cart_id: cart_id,
            product_id: product_id,
            quantity: product_quantity,
            data: data
        };

        return this.execute()
            .then((response) => {
                this.fireEvent('shop:cart.update_product.success', {
                    cart: this.cartData,
                    response: response
                });
                return response;
            })
            .catch((response) => {
                this.fireEvent('shop:cart.update_product.failed', {
                    cart: this.cartData,
                    response: response
                });

                this.fireEvent('shop:cart.response.failed', {
                    cart: this.cartData,
                    response: response
                });
                return response;

            });

    }

    removeFromCart(cart_id, data = {}) {
        this.requestType = "POST";
        this.requestURI = application.ods.urls.cart.remove;
        this.requestData = {
            cart_id: cart_id,
            data: data
        };
        return this.execute().then((response) => {
            this.fireEvent('shop:cart.remove_product.success', {
                cart: this.cartData,
                response: response
            });
            return response;
        })
            .catch((response) => {
                this.fireEvent('shop:cart.remove_product.failed', {
                    cart: this.cartData,
                    response: response
                });

                this.fireEvent('shop:cart.response.failed', {
                    cart: this.cartData,
                    response: response
                });

                return response;
            });

    }

    listCart(data = {}) {
        this.requestType = "GET";
        this.requestURI = application.ods.urls.cart.show;
        this.requestData = {
            data: data
        };
        return this.execute().then((response) => {
            this.fireEvent('shop:cart.list_cart.success', {
                cart: this.cartData,
                response: response
            });
            return response;
        })
            .catch((response) => {
                this.fireEvent('shop:cart.list_cart.failed', {
                    cart: this.cartData,
                    response: response
                });

                this.fireEvent('shop:cart.response.failed', {
                    cart: this.cartData,
                    response: response
                });
                return response;

            });

    }

    submitOrder(data = {}) {
        this.requestType = "POST";
        this.requestURI = application.ods.urls.cart.checkout;
        this.requestData = {
            ...data
        };
        return this.execute().then((response) => {
            this.fireEvent('shop:cart.submit_order.success', {
                cart: this.cartData,
                response: response
            });
            return response;
        }).catch((response) => {
            this.fireEvent('shop:cart.submit_order.failed', {
                cart: this.cartData,
                response: response
            });
            return response;
        });


    }

    checkCartItems() {

        if (typeof this.cartData.products !== 'undefined') {
            $.each(this.cartData.products, function (idx, product) {
                const elements = $('body').find(`[data-add_to_cart][data-product_id="${product.product_id}"]`);
                elements.attr('data-product_in_cart', 1);
                elements.data('product_in_cart', 1);
            });
        }
    }

    fireEvent(name, data) {
        this.checkCartItems();
        // window.appPlugins.shadowUtils.createEvent(false, name, data);
    }

}